import CroppedImage from '@sats-group/ui-lib/react/cropped-image';
import type { aspectRatios } from '@sats-group/ui-lib/react/cropped-image/cropped-image.types';
import React from 'react';
import { mod } from '~/client/helpers/add-bem-modifiers';
import { FocusArea, useImageQuery } from '~/client/hooks/use-image-query';
import Blur from '../blur/blur';
import type { DynamicImage as Props } from './dynamic-image.types';
import { themes } from './dynamic-image.types';

const DynamicImage: React.FunctionComponent<Props> & {
  aspectRatios: typeof aspectRatios;
  focusAreas: typeof FocusArea;
  themes: typeof themes;
} = ({
  // NOTE: 150/85 roughly equals 16/9
  defaultHeight = 85,
  defaultWidth = 150,
  focusArea,
  theme,
  ...props
}) => {
  const [setElement, query] = useImageQuery(
    defaultWidth,
    defaultHeight,
    focusArea
  );

  return (
    <div className={mod('dynamic-image', theme)} ref={setElement}>
      <CroppedImage {...props} srcQuery={query} />
      <Blur />
    </div>
  );
};

DynamicImage.aspectRatios = CroppedImage.aspectRatios;
DynamicImage.focusAreas = FocusArea;
DynamicImage.themes = themes;

export default DynamicImage;
